import React from 'react'
import { MdOutlineMarkEmailUnread, MdOutlineReceiptLong } from 'react-icons/md'
import { IoChevronBack, IoLogOutOutline } from 'react-icons/io5'
import { CardHeader, Typography } from '@mui/material'
import { Alerts, BttSetting, Loading } from '../../../Simple'
import { TbEdit } from 'react-icons/tb'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { HiOutlineUser } from 'react-icons/hi'
import { AppBarBottom } from '../../../Complex'
import { ExcluirDados } from '../../../Modais'
import { AuthContext } from '../../../../contexts/AuthContext'
import AlterPassword from './AlterPassword'
import EnviarEmails from './EnviarEmails'
import RouterHook from '../../../../contexts/RouterHook'
import EditDados from './EditDados'
import { Box } from '@mui/system'

import { stMob } from './styles'

export default function MobileSettings() {
  const serverRouter = RouterHook()
  const { actionsAuth, loadsAuth } = React.useContext(AuthContext)
  const { userUCtx } = React.useContext(UsuarioContext)
  const [sttPg, setSttPg] = React.useState({
    mode: 'initial', // initial, meus-dados -> (dados-pessoais || alterar-senha || envio-emails), termos-e-politicas -> (exclusao-dados || solicitar-dados)
  })
  const [modalED, setModalED] = React.useState(false)

  function ReturnSttModePg() {
    if (sttPg.mode === 'initial') {
      serverRouter('back')
    } else if (sttPg.mode === 'meus-dados') {
      setSttPg(sttPg => ({ ...sttPg, mode: 'initial' }))
    } else if (sttPg.mode === 'termos-e-politicas') {
      setSttPg(sttPg => ({ ...sttPg, mode: 'initial' }))
    } else if (sttPg.mode === 'dados-pessoais') {
      setSttPg(sttPg => ({ ...sttPg, mode: 'meus-dados' }))
    } else if (sttPg.mode === 'alterar-senha') {
      setSttPg(sttPg => ({ ...sttPg, mode: 'meus-dados' }))
    } else if (sttPg.mode === 'envio-emails') {
      setSttPg(sttPg => ({ ...sttPg, mode: 'meus-dados' }))
    } else if (sttPg.mode === 'exclusao-dados') {
      setSttPg(sttPg => ({ ...sttPg, mode: 'termos-e-politicas' }))
    } else if (sttPg.mode === 'solicitar-dados') {
      setSttPg(sttPg => ({ ...sttPg, mode: 'termos-e-politicas' }))
    }
  }

  function ReturnTitlePage() {
    if (sttPg.mode === 'initial') return 'Configurações'
    else if (sttPg.mode === 'meus-dados') return 'Meus Dados'
    else if (sttPg.mode === 'termos-e-politicas') return 'Termos e Políticas'
    else if (sttPg.mode === 'dados-pessoais') return 'Editar Dados Pessoais'
    else if (sttPg.mode === 'alterar-senha') return 'Alterar minha senha'
    else if (sttPg.mode === 'envio-emails') return 'Envio de E-mails'
    else if (sttPg.mode === 'exclusao-dados') return 'Exclusão de Dados'
    else if (sttPg.mode === 'solicitar-dados') return 'Solicitar Dados'
  }

  return (
    <Box className={'contain-page-mobile'}>
      {modalED && <ExcluirDados show={modalED} onClose={() => setModalED(false)} />}
      <CardHeader
        avatar={
          <IoChevronBack
            size={25}
            color={'#ff7043'}
            onClick={() => {
              ReturnSttModePg()
            }}
          />
        }
        title={
          <Typography variant='h5' fontWeight={'bold'}>
            {ReturnTitlePage()}
          </Typography>
        }
      />
      {loadsAuth === 'settings-page' ? (
        <div className='contain-loading'>
          <Loading text='Carregando...' />
        </div>
      ) : sttPg.mode === 'initial' ? (
        <Box sx={stMob.containList}>
          <BttSetting
            Icon={HiOutlineUser}
            title='Meus Dados'
            subTitle='Alterar dados pessoais, senha e envio de e-mails'
            onClick={() => setSttPg(sttPg => ({ ...sttPg, mode: 'meus-dados' }))}
          />
          <BttSetting
            Icon={MdOutlineReceiptLong}
            title='Termos e Políticas'
            subTitle='Termos de uso, política de privacidade e cookies'
            onClick={() => setSttPg(sttPg => ({ ...sttPg, mode: 'termos-e-politicas' }))}
          />
          <BttSetting
            Icon={IoLogOutOutline}
            title='Sair da conta'
            subTitle='Você poderá entrar novamente depois'
            onClick={() => {
              Alerts.question('Aviso', 'Você deseja realmente sair da conta?', async () => {
                await actionsAuth.StartLogout()
                serverRouter('login')
              })
            }}
          />
        </Box>
      ) : sttPg.mode === 'meus-dados' ? (
        <Box sx={stMob.containList}>
          <BttSetting
            Icon={TbEdit}
            title='Editar dados pessoais'
            subTitle=''
            onClick={() => {
              setSttPg(sttPg => ({ ...sttPg, mode: 'dados-pessoais' }))
            }}
          />
          {/* <BttSetting
            Icon={TbLockCog}
            title='Alterar minha senha'
            subTitle=''
            onClick={() => {
              setSttPg(sttPg => ({ ...sttPg, mode: 'alterar-senha' }))
            }}
          /> */}
          <BttSetting
            Icon={MdOutlineMarkEmailUnread}
            title='Envio de e-mails'
            subTitle=''
            onClick={() => {
              setSttPg(sttPg => ({ ...sttPg, mode: 'envio-emails' }))
            }}
          />
        </Box>
      ) : sttPg.mode === 'dados-pessoais' ? (
        <Box sx={stMob.containList}>
          <EditDados />
        </Box>
      ) : sttPg.mode === 'alterar-senha' ? (
        <Box sx={stMob.containList}>
          <AlterPassword />
        </Box>
      ) : sttPg.mode === 'envio-emails' ? (
        <Box sx={stMob.containList}>
          <EnviarEmails />
        </Box>
      ) : sttPg.mode === 'termos-e-politicas' ? (
        <Box sx={stMob.containList}>
          <BttSetting
            title='Termos de uso'
            subTitle=''
            onClick={() => {
              window.open('https://www.agendeiquadras.com.br/termos.html', '_blank')
            }}
          />
          <BttSetting
            title='Políticas de privacidade'
            subTitle=''
            onClick={() => {
              window.open(
                'https://www.agendeiquadras.com.br/politica-de-privacidade-agendei-quadras.html',
                '_blank',
              )
            }}
          />
          <BttSetting
            title='Política de Cookies'
            subTitle=''
            onClick={() => {
              window.open('https://www.agendeiquadras.com.br/politica-de-cookies.html', '_blank')
            }}
          />
          <BttSetting
            title='Exclusão de dados'
            subTitle=''
            onClick={() => {
              setModalED(true)
            }}
          />
          <BttSetting
            title='Solicitar cópia de dados'
            subTitle=''
            onClick={() => {
              const email = 'dados@agendeiquadras.com.br'
              const subject = encodeURIComponent('Solicitação de Cópia de Dados')
              const body = encodeURIComponent(
                `Solicito receber uma cópia dos meus dados cadastrados na plataforma Agendei Quadras. \n \n ID: ${userUCtx.usuario.idusuario} \n Nome: ${userUCtx.usuario.nome} \n Email: ${userUCtx.usuario.username}`,
              )
              const mailto = `mailto:${email}?subject=${subject}&body=${body}`

              /* Chamar envio de email */
              window.location.href = mailto
            }}
          />
        </Box>
      ) : (
        <></>
      )}
      <div className='contain-mb-app-bar-btt' />
      <AppBarBottom />
    </Box>
  )
}
